import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import { ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import {TextField,MenuItem} from '@material-ui/core';


function DynamicFieldsHeader(props) {

	const mainTheme = useSelector(selectMainTheme);

	return (
		<div className="flex flex-1 w-full items-center justify-between">
			<div className="flex items-center">
				<Icon
					component={motion.span}
					initial={{ scale: 0 }}
					animate={{ scale: 1, transition: { delay: 0.2 } }}
					className="text-24 md:text-32"
				>
					view_carousel
				</Icon>
				<Typography
					component={motion.span}
					initial={{ x: -20 }}
					animate={{ x: 0, transition: { delay: 0.2 } }}
					delay={300}
					className="hidden sm:flex text-16 md:text-24 mx-12 font-semibold"
				>
					Dynamic Fields
				</Typography>
			</div>

			<div className="flex flex-1 items-center justify-center px-12">
				<ThemeProvider theme={mainTheme}>
					<Paper
						component={motion.div}
						initial={{ y: -20, opacity: 0 }}
						animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
						className="flex items-center w-full max-w-512 px-8 py-4 rounded-16 shadow"
					>
						<Icon color="action">search</Icon>

						<TextField
							placeholder="Search"
							className="flex flex-1 mx-8"
							disableUnderline
							fullWidth
							select
							value={props.selectedTab}
							inputProps={{
								'aria-label': 'Search'
							}}
							onChange={ev => props.setSelectedTab(ev.target.value)}
						>
						{	
							props.platformModules.map(module => {
								return <MenuItem key={`module_${module.id}`} value={module.order - 1}>{module.label}</MenuItem>
							})
						}
						</TextField>
					</Paper>
				</ThemeProvider>
			</div>
		</div>
	);
}

export default DynamicFieldsHeader;
